import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { merchantTileList as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
  },
};

export const merchantTileListConfig = mergeModuleConfigs(defaultConfig, orgConfig);
